import { Link } from 'react-router-dom';
import { FREE_PLAN } from '../config/plans';

const PlanLimitAlert = ({ current, max, label, plan }) => {
    const atLimit = current >= max;
    return (
        <div className="alert alert-warning mt-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
            <span>
                {atLimit
                    ? <>Dosiahli ste maximálny počet {label} ({current}/{max}) pre plán <strong>{plan}</strong>.</>
                    : <>Plán <strong>{plan}</strong> umožňuje maximálne {max} {label} ({current}/{max}).</>
                }
                {plan === FREE_PLAN && ' Pre vyšší limit prejdite na platený plán.'}
            </span>
            <Link to="/billing" className="btn btn-sm btn-warning fw-semibold" style={{ whiteSpace: 'nowrap' }}>
                {plan === FREE_PLAN ? 'Prejsť na platený plán' : 'Zobraziť plány'}
            </Link>
        </div>
    );
};

export default PlanLimitAlert;
